<div mat-dialog-content class="mat-warp">
    <div style="max-width: 500px;">
        <div class="warp">
            <div class="item">
                <div class="cnl-top">
                    Tu auto esta actualmente asegurado con
                    <img class="img-a img-fluid" style="width: inherit;" [src]="ciaLogo">   
                </div>
            </div>        
            <div style="font-size: 15px;" class="item">
                Puedes elegir otra aseguradora
            </div>
            <div class="item">
                <ng-container *ngIf=opciones>
                    <div *ngFor="let item of opciones">
                        <div class="card-as">
                            <div class="card-top">
                                <img class="card-img" src="{{item.url}}">
                                <img class="ribetes" [src]="item.categoria">
                            </div>
                            <div class="card-btm">
                                <div style="width: 50%; font-weight: bold; color: #666666;">{{item.precio}}</div>
                                <button (click)="seleccionCompra(item)" style="width: 50%;" class="btn-cnl" mat-stroked-button>Comprar</button>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>   
            <div class="item">
                <button (click)="backCotizaciones()" class="w-100 btn-ver" mat-stroked-button>VER MAS</button>
            </div>    
            <div style="text-align: center;" class="item">
                o puedes solicitar la cancelacion de tu poliza actual
            </div>
            <div class="item">
                <button class="w-100 btn-cnl" mat-stroked-button (click)="iniciarCancelacion()">Cancelar mi poliza vigente</button>
            </div>        
        </div>
    </div>
</div>


